/* 发票 */
const Invoice = r => require.ensure([], () => r(require('./')), 'Invoice')
/* 发票详情 */
const InvoiceDetail = r => require.ensure([], () => r(require('./detail')), 'Invoice')
/* 发票更多信息 */
const InvoiceMoreInfo = r => require.ensure([], () => r(require('./moreInfo')), 'Invoice')

export default {
  path: '/invoice',
  component: Invoice,
  meta: { title: '我的订单' },
  redirect: '/invoice/detail',
  children:[
    {
      path: 'detail',
      name: 'invoiceDetail',
      meta: { title: '申请电子发票' },
      component: InvoiceDetail
    },
    {
      path: 'more-info',
      name: 'invoiceMoreInfo',
      meta: { title: '更多信息' },
      component: InvoiceMoreInfo
    }
  ]
}



// WEBPACK FOOTER //
// ./src/views/invoice/router.js